import type React from 'react';
import styled from 'styled-components';
import { StyledRteHtmlText } from '../../../../../../inputs/rich-text/style/StyledRteHtmlText.tsx';

const TitleDividerWrapper = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 6px;
`;
const TitleRteWrapper = styled.span`
  // il primo span che contiene tutto il titolo
  display: inline-block;
  padding-right: 16px;
  background-color: #fff;
`;
const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 95%;

  font-size: 18px;
  line-height: 1.4;
  font-weight: 500;

  &&& {
    ${StyledRteHtmlText};
    p {
      margin-bottom: 0;
    }
  }
`;
const LineWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
`;

const Line = styled.div`
  display: block;
  width: 100%;
  height: 2px;
  background-color: ${props =>
    props.theme.engine.accentColor ?? props.theme.colorPrimary};
`;

export interface TitleDividerProps {
  children?: React.ReactNode;
  color?: string;
}

/**
 * Elemento titolo con una linea di divisione
 */
export function TitleDivider(props: TitleDividerProps) {
  if (!props.children) {
    return null;
  }

  return (
    <TitleDividerWrapper>
      <LineWrapper>
        <Line />
      </LineWrapper>
      <TitleWrapper>
        <TitleRteWrapper>{props.children}</TitleRteWrapper>
      </TitleWrapper>
    </TitleDividerWrapper>
  );
}
